import { createStyles } from '../../../../../../../../../../../styles/helpers'
import { green } from '../../../../../../../../../../../styles/const/colors'

export default createStyles({
  discountHint: {
    color: green,
    marginTop: 5
  }
})
